export default "__VITE_ASSET__ac348725__"